// @noflow
import { Container, GraphContainer, LoadingContainer, NoDataContainer, NoDataMsgContainer } from './styles';
import GraphToolTip, { initialValues } from './graph-tool-tip';

import DOMResize from '~/components/dom/dom-resize';
import { FormattedMessage } from 'react-intl';
import Graph from './graph';
import LoadingIndicator from '~/components/widgets/indicators/loading';
import messages from './intl';
import PropTypes from 'prop-types';
import * as React from 'react';
import { responsiveVars } from './constants';

const {
    BAR_AMOUNT_LIMIT,
    GRAPH_WIDTH_MEDIUM,
    GRAPH_HEIGHT_COEF_MEDIUM,
    GRAPH_HEIGHT_COEF_SMALL,
    GRAPH_MAX_HEIGHT_COEF,
    GUTTER_SPACING_L,
    GUTTER_SPACING_S
} = responsiveVars;

const maxHeight = window.innerHeight - GRAPH_MAX_HEIGHT_COEF;

const getCompHeight = compWidth => {
    const compHeight =
        compWidth < GRAPH_WIDTH_MEDIUM ? compWidth * GRAPH_HEIGHT_COEF_SMALL : compWidth * GRAPH_HEIGHT_COEF_MEDIUM;
    return Math.min(compHeight, maxHeight);
};

const getGutterSize = dataLength => (dataLength < BAR_AMOUNT_LIMIT ? GUTTER_SPACING_L : GUTTER_SPACING_S);

export default class BarGraph extends React.Component {
    static propTypes = {
        animDuration: PropTypes.number.isRequired,
        graphData: PropTypes.array.isRequired,
        graphStyles: PropTypes.shape({
            axisColour: PropTypes.string.isRequired,
            barColours: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
            barColourMode: PropTypes.string.isRequired,
            fontColour: PropTypes.string.isRequired,
            fontFamily: PropTypes.string.isRequired,
            fontSize: PropTypes.string.isRequired
        }),
        gutter: PropTypes.number,
        margin: PropTypes.shape({
            top: PropTypes.number,
            left: PropTypes.number,
            bottom: PropTypes.number,
            right: PropTypes.number
        }),
        noData: PropTypes.bool,
        noDataMessage: PropTypes.string,
        xDomain: PropTypes.string.isRequired,
        yDomain: PropTypes.string.isRequired,
        yTicksInterval: PropTypes.number
    };

    state = {
        toolTipData: {
            backgroundColour: initialValues.backgroundColour,
            x: initialValues.x,
            xLabel: initialValues.xLabel,
            y: initialValues.y,
            yLabel: initialValues.yLabel
        }
    };

    handleSelectedBarValue = barData => {
        this.setState({
            toolTipData: { ...barData, yLabel: `${barData.yLabel}°` }
        });
    };

    handleResetBarValue = () => this.setState({ toolTipData: { ...initialValues } });

    render() {
        const {
            animDuration,
            graphData,
            graphStyles,
            gutter = getGutterSize(graphData.length),
            noData,
            noDataMessage,
            margin = {
                top: 20,
                left: 30,
                bottom: 50,
                right: 30
            },
            xDomain,
            yDomain,
            yTicksInterval = 5
        } = this.props;

        const { toolTipData } = this.state;
        return (
            <DOMResize>
                {({ width }) => {
                    const compHeight = getCompHeight(width);
                    return (
                        <Container>
                            <LoadingContainer noData={noData}>
                                <LoadingIndicator isLoading={!graphData.length} />
                            </LoadingContainer>
                            <NoDataContainer height={compHeight - margin.bottom} noData={noData}>
                                <NoDataMsgContainer containerHeight={compHeight - margin.bottom}>
                                    {!noDataMessage && <FormattedMessage {...messages.noDataMessage} />}
                                    {noDataMessage && <span>{noDataMessage}</span>}
                                </NoDataMsgContainer>
                            </NoDataContainer>
                            <GraphContainer beInvisible={!graphData.length} height={compHeight}>
                                <GraphToolTip {...toolTipData} />
                                {graphData.length &&
                                    compHeight > 0 && (
                                        <Graph
                                            animDuration={animDuration}
                                            compHeight={compHeight}
                                            compWidth={width}
                                            graphData={graphData}
                                            graphStyles={graphStyles}
                                            gutter={gutter}
                                            margin={margin}
                                            resetSelectedBarValue={this.handleResetBarValue}
                                            setSelectedBarValue={this.handleSelectedBarValue}
                                            xDomain={xDomain}
                                            yDomain={yDomain}
                                            yTicksInterval={yTicksInterval}
                                        />
                                    )}
                            </GraphContainer>
                        </Container>
                    );
                }}
            </DOMResize>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/bar-graph/index.js